/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import cleanUpResponse from '@/util/cleanUpResponse';

export default async function GetCustomerAssessmentById(assessmentId) {
  const response = await $.soap({
    body: {
      GetCustomerAssessmentById: {
        $xmlns: 'http://dla.mil/ems/bpm/assessment',
        AssessmentID: assessmentId
      }
    },
    blueprint: {
      id: '$..ID',
      type: '$..AssessmentType',
      typeID: '$..TypeID',
      attachmentId: '$..AttachmentID',
      externalUserId: '$..ExternalUserID',
      commandId: '$..CommandID',
      commandName: '$..CommandName',
      crsOwner: '$..CRSOwner',
      assignedCRS: '$..AssignedCRS',
      csFolderId: '$..CSFolderID',
      statusId: '$..StatusID',
      internalAssessmentStatus: '$..InternalAssessmentStatus',
      externalAssessmentStatus: '$..ExternalAssessmentStatus',
      createdBy: '$..CreatedBy',
      createdOn: '$..CreatedOn',
      updatedBy: '$..updatedBy',
      updatedOn: '$..UpdatedOn',
      submittedOn: '$..submittedOn',
      submittedBy: '$..submittedBy'
    }
  });

  cleanUpResponse(response);
  return response;
}
